import {put, select, takeLatest, takeLeading} from 'redux-saga/effects'

import {callIfNotExist, throwBadResponseError} from './helpers'
import {
  GET_SIZES,
  GET_SIZES_FAILURE,
  GET_SIZES_SUCCESS,
  SET_SIZES,
  getSizes,
  getSizesFailure,
  getSizesPending,
  getSizesSuccess,
  setSizesFailure,
  setSizesPending,
  setSizesSuccess,
} from '../actions/sizes'
import * as api from '../api/api'
import {InvalidSizeCombinationError} from '../exceptions'
import * as fit from '../store/fit'
import * as fitProfileSelectors from '../store/fitProfile'
import * as user from '../store/user'
import * as sizes from '../store/sizes'

import {triedInvalidSizes} from '../track/sizeSummary'

// Get Sizes
// ----------------------------------------------------------------------------

export const getSizesIfNotExist = callIfNotExist(
  sizes.isSuccess,
  getSizes,
  GET_SIZES_FAILURE,
  GET_SIZES_SUCCESS,
  'Could not get sizes.',
)

export function* getSizesWorker() {
  try {
    yield put(getSizesPending())

    const payload = yield api.getSizes(yield select(user.id)).then(
      api.onStatus({
        OK: ({json}) => json,
        404: () => undefined, // sizes don't exist for this user yet
        DEFAULT: throwBadResponseError,
      }),
    )

    yield put(getSizesSuccess(payload))
  } catch (e) {
    yield put(getSizesFailure(e))
  }
}

export function* getSizesSaga() {
  yield takeLeading(GET_SIZES, getSizesWorker)
}

// Set Sizes
// ----------------------------------------------------------------------------

export function* setSizesWorker() {
  try {
    yield put(setSizesPending())

    // combine what we know about the user's sizes with the input they've given us
    const state = yield select()
    const id = user.id(state)
    const newSizes = {...sizes.sizes(state), ...fit.sizeInputsById(state)}

    const flowName = yield select(fitProfileSelectors.flowName)

    const payload = yield api.setSizes(id, newSizes).then(
      api.onStatus({
        OK: ({json}) => json,
        400: ({json}) => {
          const errorMsgs = Object.values(json.data.errors)
          triedInvalidSizes(errorMsgs, flowName)

          throw new InvalidSizeCombinationError()
        },
        DEFAULT: throwBadResponseError,
      }),
    )

    yield put(setSizesSuccess(payload))
  } catch (e) {
    yield put(setSizesFailure(e))
  }
}

export function* setSizesSaga() {
  yield takeLatest(SET_SIZES, setSizesWorker)
}
